import type { VatMode } from '@printdeal/product-selector';

/**
 * EXP1486 — site-wide VAT toggle (NL desktop).
 * Create this experiment in Statsig and target store=drukwerkdeal-nl + device=desktop.
 */
export const VAT_TOGGLE_EXPERIMENT_ID = 'optimystics_exp1486_vat_toggle';

export const CONTROL_CART_VAT_MODE = {
  vatMode: 'totalNet' as const,
  vatModeFromUrl: undefined,
  setVatMode: () => undefined,
};

/** True when URL (`?vat=`) or a stored guest/session preference already decided the mode. */
export const hasExistingVatPreference = ({
  vatModeFromUrl,
  storedVatMode,
}: {
  vatModeFromUrl?: VatMode;
  storedVatMode?: string;
}): boolean => Boolean(vatModeFromUrl)
  || storedVatMode === 'totalNet'
  || storedVatMode === 'totalGross';

/** Visitor default when no URL/stored preference exists yet. */
export const getDefaultVatModeForVisitor = ({
  isRecognized,
  isEnduser,
  isReseller,
}: {
  isRecognized: boolean;
  isEnduser: boolean;
  isReseller: boolean;
}): VatMode => {
  if (isRecognized && (isEnduser || isReseller)) {
    return 'totalNet';
  }

  return 'totalGross';
};
